import { apiFetch } from './client'

export interface McpConnection {
  id: number
  client_id: string
  client_name: string
  scopes: string[]
  scope_labels: string[]
  created_at: string
  last_used_at: string | null
}

export interface McpClient {
  client_id: string
  name: string
  public?: boolean
}

export interface McpActivityRow {
  id: number
  created_at: string
  client_name: string
  tool: string
  result: string
  args_hash: string
  ip_address: string | null
  company_id?: number
  user_id?: number
}

export interface McpRegistration {
  client_id: string
  client_name: string
  redirect_uris: string[]
  registrant_ip: string | null
  created_at: string
  last_used_at: string | null
  revoked_at: string | null
}

export async function loadMcpConnections() {
  const res = await apiFetch<{ data: McpConnection[] }>('GET', '/api/mcp/connections')
  return res.data
}

export async function loadMcpClients() {
  const res = await apiFetch<{ data: McpClient[] }>('GET', '/api/mcp/clients')
  return res.data
}

export async function loadMcpSetup(clientId: string) {
  const res = await apiFetch<{ data: { config_json: string; instructions: string; scope_labels: string[]; authorize_url: string } }>(
    'GET',
    `/api/mcp/setup/${clientId}`,
  )
  return res.data
}

export async function revokeMcpConnection(id: number) {
  await apiFetch('DELETE', `/api/mcp/connections/${id}`)
}

export interface McpPersonalAccessToken {
  id: number
  scopes: string[]
  scope_labels: string[]
  created_at: string
  last_used_at: string | null
  expires_at: string
}

export interface McpPersonalAccessTokenIssue extends McpPersonalAccessToken {
  token: string
  shown_once: boolean
  mcp_url: string
}

export async function loadMcpPersonalAccessTokens() {
  const res = await apiFetch<{ data: McpPersonalAccessToken[] }>('GET', '/api/mcp/personal-access-tokens')
  return res.data
}

export async function createMcpPersonalAccessToken() {
  const res = await apiFetch<{ data: McpPersonalAccessTokenIssue }>('POST', '/api/mcp/personal-access-tokens')
  return res.data
}

export async function revokeMcpPersonalAccessToken(id: number) {
  await apiFetch('DELETE', `/api/mcp/personal-access-tokens/${id}`)
}

export async function loadMcpActivity(params?: { client?: string; from?: string; to?: string }) {
  const q = new URLSearchParams()
  if (params?.client) q.set('client', params.client)
  if (params?.from) q.set('from', params.from)
  if (params?.to) q.set('to', params.to)
  const suffix = q.toString() ? `?${q}` : ''
  const res = await apiFetch<{ data: { rows: McpActivityRow[] } }>('GET', `/api/mcp/activity${suffix}`)
  return res.data.rows
}

export async function loadAdminAgentActivity(params?: { company_id?: number; limit?: number }) {
  const q = new URLSearchParams()
  if (params?.company_id) q.set('company_id', String(params.company_id))
  if (params?.limit) q.set('limit', String(params.limit))
  const suffix = q.toString() ? `?${q}` : ''
  const res = await apiFetch<{ data: { rows: McpActivityRow[]; registrations: McpRegistration[] } }>(
    'GET',
    `/api/admin/agent-activity${suffix}`,
  )
  return res.data
}
